import { ENV } from '../../config/runtimeEnv';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_NOTIFICATION_BASE_URL;

export interface Template {
    id: number;
    name: string;
    type: 'sms' | 'email' | 'both';
    subject?: string;
    body: string;
    category: string;
    is_active: boolean;
    is_follow_up: boolean;
    is_reminder: boolean;
    follow_up_delay_hours?: number;
    follow_up_delay_days?: number;
    email_signature_id?: number;
    is_global?: boolean;
    admin_template_id?: number;
    created_at: Date;
    updated_at: Date;
}

export const defaultTemplate: Template = {
    id: 0,
    name: '',
    type: 'email',
    subject: '',
    body: '',
    category: 'new_patient_notification',
    is_active: false,
    is_follow_up: false,
    is_reminder: false,
    follow_up_delay_hours: undefined,
    follow_up_delay_days: undefined,
    email_signature_id: undefined,
    created_at: new Date(),
    updated_at: new Date(),
};

export const fetchTemplates = async (
    search?: string,
    followUpOnly?: boolean,
    reminderOnly?: boolean
): Promise<{ data: Template[] }> => {
    const response = await http.get(`${API_BASE_URL}/templates`, {
        params: { search, follow_up_only: followUpOnly, reminder_only: reminderOnly },
    });
    return { data: response.data };
};

export const fetchFollowUpTemplates = async (): Promise<{ data: Template[] }> => {
    const response = await http.get(`${API_BASE_URL}/templates/follow-up`);
    return { data: response.data };
};

export const fetchReminderTemplates = async (): Promise<{ data: Template[] }> => {
    const response = await http.get(`${API_BASE_URL}/templates/reminder`);
    return { data: response.data };
};

export const createTemplate = async (
    templateData: Partial<Template>
): Promise<{ data: Template; message: string }> => {
    const response = await http.post(
        `${API_BASE_URL}/templates`,
        { templateData }
    );
    return { data: response.data.data, message: response.data.message };
};

export const updateTemplate = async (
    templateData: Partial<Template>
): Promise<{ data: Template; message: string }> => {
    const response = await http.put(
        `${API_BASE_URL}/templates/${templateData.id}`,
        { templateData }
    );
    return { data: response.data.data, message: response.data.message };
};

export const deleteTemplate = async (templateId: number): Promise<{ message: string }> => {
    const response = await http.delete(`${API_BASE_URL}/templates/${templateId}`);
    return { message: response.data.message };
};